
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9 11","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.113 2.75a.73.73 0 01.528.234.771.771 0 01.234.547v2.93c0 .312-.04.586-.098.86L8.25 9.526a.852.852 0 01-.332.528.907.907 0 01-.566.195H3.484a.818.818 0 01-.43-.098.689.689 0 01-.331-.293L.28 6.5a.715.715 0 01-.156-.586.738.738 0 01.313-.508.78.78 0 01.585-.136.79.79 0 01.508.293l.625.859v-4.61a.75.75 0 01.215-.546.782.782 0 011.113 0 .782.782 0 01.235.566V5.25h.156V1.031A.75.75 0 014.09.484a.782.782 0 011.113 0 .782.782 0 01.235.567V5.25h.156V1.793a.75.75 0 01.215-.547.782.782 0 011.113 0 .782.782 0 01.234.567V5.25h.157v-1.7c0-.214.078-.41.234-.566a.751.751 0 01.566-.234z"}})])
          )
        }
      }
    